import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { breakWord, capitalizeFirstLetter, formateDate, showStatus } from "../../../../utils/commonfunction";
import * as itemServices from "../../services/itemManagement.services";
import { useTranslation } from "react-i18next";
import { Tag } from "rsuite";

const ItemView = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("heading_Items"), url: "/admin/itemManagement/list/1" },
    { title: t("link_view"), url: "" },
  ];
 
  // const selected_language = localStorage.getItem("system_language")
  // console.log(selected_language)

  useEffect(() => {
    itemServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("heading_view_items")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("list_heading_title")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.name ? showdefault?.name : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_status")}</th>
                          <td>{showdefault && showdefault?.status === 0 ? toHtml(showStatus(showdefault?.status)) : toHtml(showStatus(showdefault.status))}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_category")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.category?.title ? showdefault?.category?.title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_sub_category")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.sub_category?.title ? showdefault?.sub_category?.title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_statuses")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.statuses ? showdefault?.statuses : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_brand_name")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.brand_name ? showdefault?.brand_name : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_images")}</th>
                          <td>
                            {showdefault?.images && showdefault?.images?.length > 0 ? (
                              <div className="d-flex flex-wrap gap-2">
                                {showdefault?.images.map((img, index) => (
                                  <img
                                    key={index}
                                    src={`${process.env.REACT_APP_SERVER_BASE_URL}/${img}`}
                                    alt="outfit"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      objectFit: "cover",
                                      borderRadius: "6px",
                                      border: "1px solid #ddd",
                                    }}
                                  />
                                ))}
                              </div>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_care")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.care ? showdefault?.care : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_fabric")}</th>
                          <td>
                            {showdefault?.fabric?.length > 0
                              ? showdefault.fabric.map((fabric, index) => (
                                  <span className="text-capitalize" key={index}>
                                    {fabric}
                                    {index !== showdefault.fabric.length - 1 && ", "}
                                  </span>
                                ))
                              : "-"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_color")}</th>
                          <td>
                            {showdefault?.colors?.length > 0
                              ? showdefault.colors.map((colors, index) => (
                                  <span key={index} className="text-capitalize">
                                    {colors}
                                    {index !== showdefault.colors.length - 1 && ", "}
                                  </span>
                                ))
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_tag")}</th>
                          <td>
                            {showdefault?.tags?.length > 0
                              ? showdefault.tags.map((tag, index) => (
                                  <span key={index} className="text-capitalize">
                                    {tag}
                                    {index !== showdefault.tags.length - 1 && ", "}
                                  </span>
                                ))
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_mood")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.mood ? showdefault?.mood : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_season")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.season ? showdefault?.season : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_size")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.size ? showdefault?.size : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_chest")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.measurements?.chest ? showdefault?.measurements?.chest : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_sleeve_length")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.measurements?.sleeve_length ? showdefault?.measurements?.sleeve_length : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_waist")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.measurements?.waist ? showdefault?.measurements?.waist : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_inseam")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.measurements?.inseam ? showdefault?.measurements?.inseam : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_hip")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.measurements?.hip ? showdefault?.measurements?.hip : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_occasion")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.occasion ? showdefault?.occasion : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_price")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.price ? showdefault?.price : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_match_with_my_size")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.match_with_my_size ? showdefault?.match_with_my_size : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_notes")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.notes ? showdefault?.notes : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault && showdefault?.createdAt ? formateDate(showdefault?.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>{showdefault && showdefault?.updatedAt ? formateDate(showdefault?.updatedAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <h6 className="main-content-label mb-3">{t("label_description")}:</h6> */}
                    {/* <div className="">{toHtml(showdefault && showdefault.description ? showdefault.description : "N/A")}</div> */}
                    {/* <div
                      className="text-capitalize"
                      dangerouslySetInnerHTML={{
                        __html: showdefault && showdefault?.description ? showdefault.description : "N/A",
                      }}></div> */}
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemView;
